export default "__VITE_ASSET__DH6aIdA8__"